import { render } from "./LootBoxOpenRoulette.vue?vue&type=template&id=bb40787a"
import script from "./LootBoxOpenRoulette.vue?vue&type=script&lang=js"
export * from "./LootBoxOpenRoulette.vue?vue&type=script&lang=js"

import "./LootBoxOpenRoulette.vue?vue&type=style&index=0&id=bb40787a&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__